"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSidePanelOpenState = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var useSidePanelOpenState = exports.useSidePanelOpenState = function useSidePanelOpenState(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  var didRenderRef = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    internalIsOpen = _useState2[0],
    setInternalIsOpen = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!didRenderRef.current) {
      setTimeout(function () {
        setInternalIsOpen(isOpen);
        didRenderRef.current = true;
      });
      return;
    }
    setInternalIsOpen(isOpen);
  }, [isOpen]);
  var closeSidePanel = (0, _react.useCallback)(function () {
    setInternalIsOpen(false);
  }, []);
  var onTransitionEnd = (0, _react.useCallback)(function () {
    if (!internalIsOpen) {
      onClose === null || onClose === void 0 || onClose();
    }
  }, [internalIsOpen, onClose]);
  return {
    closeSidePanel: closeSidePanel,
    internalIsOpen: internalIsOpen,
    onTransitionEnd: onTransitionEnd
  };
};
//# sourceMappingURL=useSidePanelOpenState.js.map